import './badge.css';

const Badge = ({ text, type, inline }) => {
  return (
    <div className={`badge-status ${type} ${inline ? 'inline-badge' : ''}`}>
      <div className='badge-status-dot'></div>
      {text}
    </div>
  );
};

export default Badge;
